import React from 'react';
import { useTranslation } from 'react-i18next';

import { SampleStorageTypeEnum } from 'constants/samples';

import { LabSampleType } from 'store/labSamples/types';
import { Banner } from 'common';

type FrozenSamplePropsType = {
  sample: LabSampleType;
};

export const FrozenSample = ({ sample }: FrozenSamplePropsType) => {
  const { t } = useTranslation();
  return (
    <>
      {sample.storage_options === SampleStorageTypeEnum.COLD_STORAGE && (
        <Banner headingText={t('frozenSample')} />
      )}
    </>
  );
};
